export const navigation = [
  // { name: 'Dashboard', href: '/dashboard', current: true },
  { name: 'Quotation', href: '', current: false },
  { name: 'Job Management', href: '#', current: false },
  { name: 'Billing', href: '#', current: false },
];
